import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import SimpleError from 'views/component/SimpleError.js';

// images
import FactoryIcon from 'assets/img/factory.png';

import styles from 'views/component/Styles.js';

const useStyles = makeStyles(styles);

export default function MainPage(props) {
    const classes = useStyles();
    const history = useHistory();

    const [projectList, setProjectList] = useState([]);
    const [projectSelected, setProjectSelected] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        axios.get('data/project/list')
            .then(response => {
                let projectList = response.data;
                if (window.sessionStorage.getItem('isAdmin') === 'false') {
                    const auth = window.sessionStorage.getItem('projectList').split(',').map(item => parseInt(item));
                    projectList = projectList.filter(item => auth.includes(item.projectId));
                }
                setProjectList(projectList);
            });
    }, []);

    const onConfirmButtonClick = function () {
        if (projectSelected) {
            history.push('/aps/info', {
                "factory_id": projectSelected,
                'factory_name': projectList.filter(item => item.projectId === projectSelected)[0].name
            });
        } else {
            setError(true);
        }
    };

    return (
        <GridContainer justify="center" direction='column' alignItems="center" style={{ marginTop: '15vh' }}>
            <SimpleError show={error} title="공장을 선택해주세요." onConfirm={e => setError(false)} />
            <GridItem>
                <img src={FactoryIcon} width='90' height='90' style={{ margin: 80, marginBottom: 20 }} />
            </GridItem>
            <GridItem className={classes.center}>
                <h5><b>안녕하세요!<br />
                    <h5 className={classes.infoText} style={{ display: 'inline' }}>FACTORY DOCTOR</h5> 입니다.</b></h5>
                <br />
                <h5><b>대상 공장을 선택해주세요.</b></h5>
            </GridItem>
            <GridItem style={{ minWidth: '250px' }}>
                <FormControl fullWidth className={classes.selectFormControlInfo}>
                    <InputLabel htmlFor="projectSelect" className={classes.selectLabel}>
                        고객사
                        </InputLabel>
                    <Select MenuProps={{ className: classes.selectMenu }} classes={{ select: classes.select }}
                        value={projectSelected} onChange={e => { setProjectSelected(e.target.value) }} inputProps={{ id: "projectSelect" }}>
                        {projectList.map((project) => {
                            return <MenuItem classes={{ root: classes.selectMenuItemInfo, selected: classes.selectMenuItemSelectedInfo }}
                                value={project.projectId} key={project.projectId}>
                                {project.name}
                            </MenuItem>;
                        })}
                    </Select>
                </FormControl>
                <Button fullWidth color="info" style={{ marginTop: 15 }} onClick={onConfirmButtonClick}>확인</Button>
            </GridItem>
        </GridContainer>
    );
}